import type { Brochure } from '../types/content'

// href: null renders a "PDF link supplied" tag until the real PDF URL is added.
// The RFB40X Series brochure is intentionally excluded (no longer sold).
export const brochures: Brochure[] = [
  {
    id: 'standalone-pv',
    title: 'Standalone PV Power Generating System',
    summary: 'Off-grid solar generation with storage, for sites without a reliable grid.',
    href: null,
  },
  {
    id: 'disaster-response',
    title: 'Disaster Response System',
    summary: 'Transportable power for emergency and recovery operations.',
    href: null,
  },
  {
    id: 'mwh-storage',
    title: 'MWh Energy Storage System',
    summary: 'Large-scale storage for solar farms and grid support.',
    href: null,
  },
]
